import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';
import { map, share } from 'rxjs/operators';
import { UserInfo } from '../core/classes/user-info'
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    private endpoint = environment.ccpApiUrl + '/ccp/user/info';

    private userObject: UserInfo;

    private promise: Promise<UserInfo>;

    constructor(private http: HttpClient) { }

    public getUser(): Promise<UserInfo> {
        if (this.userObject) {
            // if we have userObject defined, we do not need the promise variable
            this.promise = void 0;
            return of(this.userObject).toPromise();
        } else if (this.promise) {
            return this.promise;
        } else {
            this.promise = this.http.get(this.endpoint).pipe(
                map(
                    (response: any) => {
                        this.userObject = new UserInfo(response);
                        return this.userObject;
                    }
                ),
                share()
            ).toPromise();
            return this.promise;
        }
    }
}
